import { FC } from 'react'
import { Box, Typography, Dialog } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Icon } from 'packages/eid-icons'
import { IconButton } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'

const mobileScreenWidth = '767px'

const StyledDialog = styled(Dialog)(() => ({
    '& .MuiDialog-paper': {
        borderRadius: 10,
        maxWidth: '800px',
        [`@media (max-width:${mobileScreenWidth})`]: {
            margin: '8px ',
            width: 'calc(100% - 16px) !important',
            maxWidth: 'calc(100% - 16px) !important ',
        },
    },
}))

const ModalBody = styled(Box)(({ theme }: any) => ({
    backgroundColor: theme?.palette?.background?.default,
    padding: '24px 40px',
    '&:focus': {
        outline: 'none',
    },
    [`@media (max-width:${mobileScreenWidth})`]: {},
}))

const ModalHeader = styled(Box)(({ theme }: any) => ({
    display: 'flex',
    justifyContent: 'space-between',
    maxHeight: '12%',
    padding: '28px 12px 16px 28px',
    backgroundColor: theme?.palette?.background?.paper,
}))

const CloseIcon = styled(Box)(() => ({
    display: 'flex',
    height: '13px',
    marginTop: '-13px',
}))

const Title = styled(Typography)(() => ({
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#3b454d',
}))

const Footer = styled(Box)(({ theme }: any) => ({
    backgroundColor: theme?.palette?.background?.paper,
}))

export interface ModalProps {
    open?: any
    onClose?: any
    title?: any
    children?: React.ReactNode
    footerContent?: any
    headerContent?: any
    disableClose?: boolean
}

export const Modal: FC<ModalProps> = (props) => {
    const {
        open,
        onClose,
        title,
        children,
        headerContent,
        footerContent,
        disableClose,
    } = props

    const { t } = useTranslation()

    return (
        <StyledDialog
            scroll={'body'}
            open={open}
            onClose={disableClose ? null : onClose}
            aria-labelledby="modal-dialog-title"
            aria-describedby="modal-dialog-body"
        >
            <ModalHeader>
                {!headerContent ? (
                    <Title id="modal-dialog-title">{title}</Title>
                ) : (
                    headerContent
                )}
                {!disableClose && (
                    <CloseIcon>
                        <IconButton
                            onClick={onClose}
                            size="large"
                            aria-label={t('Common_Close')}
                        >
                            <Icon
                                style={{ height: 13, width: 13 }}
                                name="Close"
                                color="#727272"
                            />
                        </IconButton>
                    </CloseIcon>
                )}
            </ModalHeader>

            {children && <ModalBody id="modal-dialog-body">{children}</ModalBody>}

            {footerContent && <Footer>{footerContent}</Footer>}
        </StyledDialog>
    )
}
